var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTierGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1239 1239",
    style: {
      enableBackground: "new 0 0 1239 1239"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA830A;}\n\t.st1{fill:#FFD56E;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 619.5,
    cy: 619.5,
    r: 619.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.6,704.8L497.6,704.8l-0.2-0.1L497.6,704.8z M1027.4,617.1l-61.5-162.7L742.4,333L279.3,579.8l-67.7,180.9 l273,145.2l4.5-196.9L276.7,587.9l18.2,9.6l-10.4-6l37.1,19.7l-33.8-19.7l209.6,113.2L949,471.4l-72.3,39.7l84.6-43.2l-167.4,88.7 L503.2,716.1L484.6,906L1027.4,617.1L1027.4,617.1z M506.6,648l-122.3-65.2l118.9,36.8L867.3,458L506.6,648L506.6,648z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierGold);
export default __webpack_public_path__ + "static/media/tier_gold.ea8b9417d7e9c465df1977ef3dd6e787.svg";
export { ForwardRef as ReactComponent };